exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media(min-width: 640px){.modal-module-Width{min-width:600px;max-width:600px}}", ""]);

// Exports
exports.locals = {
	"Width": "modal-module-Width"
};